var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerOppgaverUtdanningsvalgSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikoner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.91,30.24H24.85a.31.31,0,1,1,0-.62H29.6V18.53a.31.31,0,0,1,.61,0v11.4A.31.31,0,0,1,29.91,30.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.91,13.91a.31.31,0,0,1-.31-.31v-.5H26.45a.3.3,0,0,1-.3-.31.29.29,0,0,1,.3-.3h3.46a.3.3,0,0,1,.3.3v.81A.31.31,0,0,1,29.91,13.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.62,30.24H12.38a.3.3,0,0,1-.3-.31V27.49a.29.29,0,0,1,.3-.3.3.3,0,0,1,.31.3v2.13h6.93a.31.31,0,0,1,0,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.31,31.82l-.09,0L7.61,26.21a.29.29,0,0,1-.19-.39L13,9.22A.31.31,0,0,1,13.4,9L30,14.62a.31.31,0,0,1,.2.39l-5.6,16.6A.3.3,0,0,1,24.31,31.82ZM8.1,25.73l16,5.39,5.4-16-16-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.85,17.6a2,2,0,0,1-2-2v-2a.31.31,0,1,1,.61,0v2a1.43,1.43,0,1,0,2.86,0v-4A1.43,1.43,0,0,0,19.52,11a.31.31,0,0,1-.4.17.32.32,0,0,1-.17-.4,2,2,0,0,1,3.95.76v4A2.05,2.05,0,0,1,20.85,17.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.85,16.3a.75.75,0,0,1-.74-.74v-2a.31.31,0,0,1,.62,0v2a.12.12,0,0,0,.12.12.31.31,0,1,1,0,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.25,23.76l-.1,0-6.31-2.13a.3.3,0,0,1-.2-.38A.32.32,0,0,1,15,21l6.31,2.13a.31.31,0,0,1,.2.39A.32.32,0,0,1,21.25,23.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,21.31h-.1l-6.31-2.13a.31.31,0,0,1,.19-.58l6.32,2.13a.3.3,0,0,1-.1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.31,26.29l-.1,0L13.9,24.15a.3.3,0,0,1-.19-.39.3.3,0,0,1,.39-.19l6.31,2.12a.3.3,0,0,1,.19.39A.3.3,0,0,1,20.31,26.29Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerOppgaverUtdanningsvalgSmall);
export default __webpack_public_path__ + "static/media/Ikoner_Oppgaver-utdanningsvalg_small.0849a887a479c865729ffbd60352b80e.svg";
export { ForwardRef as ReactComponent };